export { MT_MODULES } from '~/components/CommonConstants';

export const MODULE_LINK_TYPE = {
  BUILD: 'BUILD',
  INVITE_TRACK: 'INVITE_TRACK',
  ANALYTICS: 'ANALYTICS',
};
